
import { defineComponent, PropType, computed } from 'vue'
import { STYLE_TYPE_LIST, STYLE_TYPE_OBJ } from '../../const'
import { styleType, sizeType } from '../../interface'
export default defineComponent({
  name: 'KInput',
  props: {
    // input接收的属性
    type: {
      type: String,
      default: 'text'
    },
    theme: {
      type: String as PropType<styleType>,
      default: STYLE_TYPE_OBJ.default,
      validator: (val: string) => STYLE_TYPE_LIST.includes(val)
    },
    size: {
      type: String as PropType<sizeType>
    },
    disabled: Boolean,
    placeholder: {
      type: String,
      default: '请输入'
    },
    style: [String, Object],
    // 外框接的收属性
    inputStyle: { type: String, default: '' },
    iscontainer: { type: Boolean }
  },
  emits: ['input', 'focus', 'blur', 'change', 'keydown', 'keyup'],
  setup(props, ctx) {
    const classes = computed(() => [
      `k-input--${props.theme}`,
      props.size ? `k-input--${props.size}` : '',
      {
        'is-disabled': props.disabled
      }
    ])
    function onInput(e: Event) {
      ctx.emit('input', e)
    }
    function onFocus(e: Event) {
      ctx.emit('focus', e)
    }
    function onBlur(e: Event) {
      ctx.emit('blur', e)
    }
    function onChange(e: Event) {
      ctx.emit('change', e)
    }
    function onKeydown(e: Event) {
      ctx.emit('keydown', e)
    }
    function onKeyup(e: Event) {
      ctx.emit('keyup', e)
    }
    return {
      classes,
      onInput,
      onFocus,
      onBlur,
      onChange,
      onKeydown,
      onKeyup
    }
  }
})
